import React from 'react'
import Icon from './Icon'
import I18nSelect from './I18nSelect'
import R from 'ramda'

const PoiTop = ({index, poi, options, onDelete, onChange, onSelect}) => {

  return <div className="poi-top">
      <div className="poi-top-description-container">
        { R.not(poi.type) ? 
            <div className="poi-top-left-container">
                <div className="poi-markercount-container">
                    <span className="markercount">{poi.markerCount}</span>
                </div>
            </div> 
            : null
        }
      
        <div>
           { R.not(poi.type) ? 
            <a onClick={onSelect}>
               {poi.description}
            </a> 
            : <span>{poi.description}</span>
           }
        </div>

        <div className="poi-top-buttons-container">
          <div className="btn btn-link" style={{display: 'inline-block'}} onClick={onDelete}>
            <Icon name="times" />
          </div>
        </div>
    </div>
    
    <div style={{display:'flex', flexDirection:'row'}}>
      <div className="poi-transport-type">
        <I18nSelect labelKey="name" 
            valueKey="id" 
            value={poi.transportationType} 
            options={options.transportationTypes} 
            searchable={false}
            clearable={false}
            onChange={(option) => onChange(['pois', index, 'transportationType'], option.id)}
            />
      </div>
    

      <div className="poi-travel-duration">
        <I18nSelect 
          labelKey="label" 
          valueKey="value" 
          value={poi.travelDuration} 
          options={options.travelDurations} 
          searchable={false}
          clearable={false}
          onChange={(option) => onChange(['pois', index, 'travelDuration'], option.value)}
          />
      </div>


    </div>

  </div>
}

PoiTop.propTypes = {
  poi: React.PropTypes.shape({
    name: React.PropTypes.string,
    description: React.PropTypes.string.isRequired,
    travelDuration: React.PropTypes.number.isRequired,
    transportationType: React.PropTypes.string.isRequired,
    isOpen: React.PropTypes.bool.isRequired,
  }).isRequired,
  index: React.PropTypes.number.isRequired,
  options: React.PropTypes.shape({
    travelDurations: React.PropTypes.array.isRequired,
    transportationTypes: React.PropTypes.array.isRequired,
  }),
  onSelect: React.PropTypes.func.isRequired,
  onDelete: React.PropTypes.func.isRequired,
  onChange: React.PropTypes.func.isRequired,
}

export default PoiTop



/** WEBPACK FOOTER **
 ** ./app/components/PoiTop.jsx
 **/